const ELEMENTS_WITH_POSSIBLE_FOCUS =
  'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';

/**
 * Get all focusable elements inside element
 * https://zellwk.com/blog/keyboard-focusable-elements/
 */
export const getFocusableElements = (element: HTMLElement = document.body) => {
  return Array.from(element.querySelectorAll(ELEMENTS_WITH_POSSIBLE_FOCUS)).filter(
    el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && el.getAttribute('tabindex') !== '-1',
  ) as HTMLElement[];
};

export const isFocusInsideElement = (element: HTMLElement): boolean => {
  const focusableElements = getFocusableElements(element);
  return !!document.activeElement && focusableElements.includes(document.activeElement as HTMLElement);
};

/**
 * Change focus of any focussable element inside element by native browser focus
 */
export const handleFocusInElement = (element: HTMLElement = document.body, direction: -1 | 1 = 1): void => {
  const focusableElements = getFocusableElements(element);
  if (!focusableElements.length) return;

  const currentFocus = document.activeElement;
  const currentFocusableIndex = focusableElements.indexOf(currentFocus as HTMLElement);

  if (currentFocusableIndex >= 0) {
    let nextIndex = currentFocusableIndex + direction;
    if (nextIndex < 0) nextIndex = focusableElements.length - 1;
    if (nextIndex >= focusableElements.length) nextIndex = 0;
    (focusableElements[nextIndex] as HTMLElement).focus();
  } else {
    (focusableElements[0] as HTMLElement).focus();
  }
};
